// extracted by mini-css-extract-plugin
export var layoutContainer = "_5p-0";
export var layoutContainerNoRounding = "_5p-6";
export var layoutContainerOpen = "_5p-5";
export var layoutContainerResizing = "_5p-1";
export var mainContent = "_5p-2";
export var resizeDivider = "_5p-3";
export var slidePanel = "_5p-4";